export default "__VITE_ASSET__DosW$0xT__"